/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VapiOpenAIModel } from './VapiOpenAIModel';
/**
 * Interface representing Vapi OpenAI model configuration
 */
export type VapiOpenAIModelConfig = {
    provider: VapiOpenAIModelConfig.provider;
    model: VapiOpenAIModel;
};
export namespace VapiOpenAIModelConfig {
    export enum provider {
        OPENAI = 'openai',
    }
}

